import React from 'react';
import _ from 'lodash';

const IntlContext = React.createContext({
  currency: () => '',
  date: () => '',
});

const currencyMap = {
  'en-US': 'USD',
  'en-CA': 'CAD',
  'fr-CA': 'CAD',
  'pt-BR': 'BRL',
};

const getCurrencyFormatter = (locale) => {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: _.get(currencyMap, locale, 'USD'),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  } catch (e) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: _.get(currencyMap, locale, 'USD'),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
};
export class IntlProvider extends React.Component {
  constructor(props) {
    super(props);
    const { language, country } = this.props;
    const locale = `${language}-${country}`;
    const currencyFormatter = getCurrencyFormatter(locale);
    const formatDate = (value) => {
      const date = new Date(value);

      const formatter = new Intl.DateTimeFormat(locale, {
        month: locale === 'en-CA' ? 'long' : 'short',
        year: 'numeric',
        day: 'numeric',
      });

      if (locale === 'pt-BR' && formatter.formatToParts) {
        return formatter
          .formatToParts(date)
          .map((x) => (x.type === 'literal' ? '/' : x.value))
          .join('');
      }

      return formatter.format(date);
    };

    const formatTime = (value) => {
      const date = new Date(value);

      const formatter = new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        minute: 'numeric',
      });

      if (formatter.formatToParts) {
        return formatter
          .formatToParts(date)
          .map((x) =>
            x.type === 'dayPeriod'
              ? x.value === 'AM'
                ? 'a.m.'
                : 'p.m.'
              : x.value
          )
          .join('');
      }

      return formatter.format(date);
    };

    this.intlContext = {
      currency: currencyFormatter.format,
      date: formatDate,
      time: formatTime,
    };
  }

  render() {
    return (
      <IntlContext.Provider value={this.intlContext}>
        {this.props.children}
      </IntlContext.Provider>
    );
  }
}

export default IntlContext;
